import { Link } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import { useStoreState } from 'easy-peasy';
import { ADMIN_COMPANY_ID } from '~/constants';
import {
  NavigationMenu,
  NavigationMenuList,
  NavigationMenuItem,
  NavigationMenuLink,
} from '@/components/ui/navigation-menu';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import Icon from 'Components/Icon';
import SolutionPicker from 'Components/SolutionPicker';
import LanguageSelector from 'Components/LanguageSelector';
import Logomark from '@/assets/img/logomark.svg?react';
import EnvBadge from '@/components/EnvBadge';

const TopNav = () => {
  const { formatMessage } = useIntl();
  const user = useStoreState((state) => state.auth.userModel);
  const isadmin = user?.company?.id === ADMIN_COMPANY_ID;
  const domain = isadmin ? import.meta.env.VITE_APP_OLD_DOMAIN : undefined;
  return (
    <div className="tw:h-10">
      <nav className="tw tw:bg-[#E8EDF5] tw:px-2 tw:fixed tw:top-0 tw:w-full tw:z-50">
        <EnvBadge />
        <NavigationMenu>
          <NavigationMenuList>
            <NavigationMenuItem>
              <NavigationMenuLink asChild>
                <Link
                  to="/home"
                  className="tw:flex tw:flex-row tw:items-center tw:gap-2 tw:text-gray-500 tw:hover:bg-inherit tw:active:bg-inherit tw:focus:bg-inherit tw:focus:text-gray-500"
                >
                  <Logomark className="tw:w-4.5 tw:h-4.5" />
                  <FormattedMessage id="topnav-home" defaultMessage="Home" />
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>
            <SolutionPicker />
            {isadmin && domain && (
              <NavigationMenuItem>
                <NavigationMenuLink
                  asChild
                  className="tw:hover:bg-inherit tw:active:bg-inherit tw:focus:bg-inherit tw:focus:text-gray-500"
                >
                  <a
                    href={`${domain}/signin`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="tw:text-gray-500"
                  >
                    <FormattedMessage
                      id="topnav-admin-link"
                      defaultMessage="Admin"
                    />
                  </a>
                </NavigationMenuLink>
              </NavigationMenuItem>
            )}
            <NavigationMenuItem className="tw:ml-auto">
              <Tooltip>
                <TooltipTrigger asChild>
                  <NavigationMenuLink
                    asChild
                    className="tw:px-1 tw:hover:bg-inherit tw:active:bg-inherit tw:focus:bg-inherit tw:focus:text-gray-500"
                  >
                    <a
                      href={
                        import.meta.env.VITE_APP_PORTAL_URL ||
                        'https://portal.nuimarkets.com'
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                      className="tw:text-gray-500"
                      aria-label={formatMessage({
                        id: 'topnav-portal-link',
                        defaultMessage: 'Nui Portal',
                      })}
                    >
                      <Icon name="dashboard" />
                    </a>
                  </NavigationMenuLink>
                </TooltipTrigger>
                <TooltipContent>
                  <FormattedMessage
                    id="navbar-tab-portal"
                    defaultMessage="The Nui Portal, gives you a unique view of physical trade across our marketplaces, and oversight of upcoming tenders across all Nui platforms."
                  />
                </TooltipContent>
              </Tooltip>
            </NavigationMenuItem>
            <NavigationMenuItem className="tw:-mr-2">
              <LanguageSelector />
            </NavigationMenuItem>
            <NavigationMenuItem>
              <NavigationMenuLink
                asChild
                className="tw:px-1 tw:hover:bg-inherit tw:active:bg-inherit tw:focus:bg-inherit tw:focus:text-gray-500"
              >
                <Link
                  to="/account"
                  className="tw:text-gray-500"
                  aria-label={formatMessage({
                    id: 'topnav-account-link',
                    defaultMessage: 'Account',
                  })}
                >
                  <Icon name="account_circle" />
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>
          </NavigationMenuList>
        </NavigationMenu>
      </nav>
    </div>
  );
};

export default TopNav;
